/* eslint-disable */

import { getSessionEvents } from '@/api/oversight';
import { SessionEvent } from '@/api/oversight/types';
import Snackbar from '@/components/Snackbar';
import { IconArrowForwardMS, IconCloseMS } from '@/constants/icons';
import { GlobalContext } from '@/context/global';
import useErrorMessage from '@/hooks/useErrorMessage';
import useSnackbar from '@/hooks/useSnackbar';
import { Button } from '@/pages/Oversight/components/Button';
import { Timeline } from '@/pages/Oversight/components/Timeline';
import { WarningOutlined } from '@mui/icons-material';
import { Divider, IconButton, Tab } from '@mui/material';
import { useContext, useEffect, useState } from 'react';

import '@sinm/react-chrome-tabs/css/chrome-tabs.css';
import { useParams } from 'react-router-dom';
import { StyledTitle } from '../CustomerDetails/styles';
import {
  Container,
  ContainerInfo,
  DateTypography,
  DurationTypography,
  ErrorBox,
  Label,
  Span,
  StatusBadge,
  TopContainer,
} from './styles';

type SectionClientProps = {
  id?: string;
  sessionId?: number;
  source?: 'delegated_access' | 'section_client' | 'section_adm_user';
  onClose: () => void;
  onActivityClick?: (id: number) => void;
  userRole?: string;
};

type Tab = {
  id: string;
  title: string;
  active?: boolean;
};

export function SectionClient({
  id,
  sessionId,
  source,
  onClose,
  onActivityClick,
  userRole,
}: SectionClientProps): JSX.Element {
  const [currentDate, setCurrentDate] = useState('');
  const [events, setEvents] = useState<SessionEvent[]>([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const { handleSnackbar } = useSnackbar();
  const { getErrorMessage } = useErrorMessage();

  const fetchEvents = async (pageToLoad: number): Promise<void> => {
    if (!sessionId) return;

    try {
      const { data } = await getSessionEvents(sessionId, pageToLoad);
      if (data) {
        setEvents((prev) =>
          pageToLoad === 1
            ? data.session_events
            : [...prev, ...data.session_events]
        );
        setTotalPages(data.pages);
        setPage(data.current_page);
      }
    } catch (error) {
      handleSnackbar(getErrorMessage(error), true);
    }
  };

  useEffect(() => {
    fetchEvents(1);
  }, [sessionId]);
  const titleMap = {
    delegated_access: 'Acesso Delegado',
    section_client: 'Sessão do Cliente',
    section_adm_user: 'Sessão do Usuário Administrativo',
  };

  const { openSnackbar } = useContext(GlobalContext);
  const { flag } = useParams();

  const handleGetCurrentDate = (): void => {
    const date = new Date();

    const formattedDate = `${date.toLocaleDateString(
      'pt-BR'
    )} às ${date.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
    })}`;

    setCurrentDate(formattedDate);
  };

  return (
    <Container>
      {!flag?.includes('administrative') && (
        <TopContainer>
          <IconButton onClick={() => onClose()}>{IconCloseMS}</IconButton>
        </TopContainer>
      )}
      <StyledTitle>
        {source ? titleMap[source] : 'Sessão do cliente'}
      </StyledTitle>

      <ContainerInfo>
        <Span>
          <Label>Status:</Label>{' '}
          {currentDate !== '' ? (
            <>
              Sessão encerrada {IconArrowForwardMS} {currentDate}
            </>
          ) : (
            <>
              <StatusBadge /> Online
            </>
          )}
        </Span>
        {currentDate === '' && userRole !== 'operator' && (
          <Button
            variant="outlined"
            rounded
            isRedButton
            onClick={() => handleGetCurrentDate()}
          >
            Encerrar sessão
          </Button>
        )}

        <Span>
          <Label>Atividade:</Label> 12
          <ErrorBox>
            <WarningOutlined fontSize="small" /> 2 erros
          </ErrorBox>
        </Span>
        <Span>
          <Label>Versão:</Label> 2.03
        </Span>
        <Span>
          <Label>Sistema operacional:</Label> iOS 11
        </Span>
        <Span>
          <Label>Navegador:</Label> Chrome
        </Span>
      </ContainerInfo>

      <Divider sx={{ margin: '32px 0' }} />

      <DateTypography>12 de maio de 2026</DateTypography>
      <DurationTypography>Duração: 13 minutos</DurationTypography>

      <Timeline
        source={source}
        events={sessionId ? events : undefined}
        onActivityClick={onActivityClick}
      />
      {sessionId && page < totalPages && (
        <Button variant="text" onClick={() => fetchEvents(page + 1)}>
          Carregar mais
        </Button>
      )}
      {openSnackbar && <Snackbar />}
    </Container>
  );
}
